var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('van-nav-bar',{staticClass:"topNav userinfo",attrs:{"title":"质保单详情","left-text":"","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('div',{staticClass:"content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }